import { Button, Divider } from 'antd';

import useAuth from 'hooks/useAuth';
import useNotice from 'hooks/useNotice';
import { useNavigate } from 'react-router-dom';
import { DELETE, notiDropDownProps, PUT } from 'utils';
import { api } from 'utils/apiRoutes';

import dayjs from 'dayjs';
import React from 'react';

const NotiDropdown = (props: notiDropDownProps) => {
  const { postNoti } = useNotice();
  const navigate = useNavigate();
  const { user } = useAuth();
  function handelNotification(type: String, action?: String) {
    props.isOpen();
    switch (type) {
      case 'public_holiday_calendar':
        navigate('/staff_leave_&_absences/public_holidays');
        break;
      case 'workshift_policy':
        navigate('/general_settings/workshift_calendar');
        break;
      case 'absence_policy':
        navigate('/staff_leave_&_absences/staff_leave_profile');
        break;
      case 'absence_type':
        navigate('/staff_leave_&_absences/staff_leave_and_absence_types');
        break;

      case 'absence_request':
        if (action === 'remind_approval') {
          navigate('/request_approval');
        } else {
          navigate('/my_request');
        }
        break;
      case 'user':
        navigate('/employee_directory');
        break;
      case 'service':
      case 'department':
        if (user?.role === 'admin') {
          navigate('/general_settings/departments');
        }
        break;
      default:
        navigate('/');
    }
  }

  return (
    <div
      style={{ width: 400, padding: '0px' }}
      className={'layout_header_menu_dropdown'}
    >
      <div
        className={'layout_header_menu_dropdown_wrapper'}
        style={{
          borderBottom: '1px solid #75ACFF',
          padding: '16px',
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <div style={{}}>
          <span
            style={{ fontWeight: 600, color: '#000000' }}
            className={'layout_header_menu_dropdown_menu'}
            onClick={() =>
              postNoti('user', 'created', `${Math.random()}`, 'abc')
            }
          >
            Notifications
          </span>
          <Button
            type={'text'}
            style={{
              marginLeft: '105px',
              color: '#407fdd',
              fontWeight: 600,
              fontSize: 12,
            }}
            onClick={props.markAsRead}
          >
            {' '}
            Mark as all read
          </Button>
        </div>
        <Button
          onClick={props.isOpen}
          icon={
            <img
              src="/icons/close.svg"
              alt="close-icon"
              height={20}
              width={20}
            />
          }
          type="text"
        />
      </div>
      <Divider
        style={{ marginTop: '0px', marginBottom: '0px' }}
        orientation="left"
      />
      {props.noti?.length !== 0 ? (
        <>
          <div
            style={{ maxHeight: '500px', overflowY: 'scroll' }}
            onScroll={(e: React.UIEvent<HTMLDivElement>) => {
              const { scrollHeight, clientHeight, scrollTop } = e.currentTarget;
              const toBottom = clientHeight + scrollTop >= scrollHeight;
              if (toBottom) {
                props.loadMore();
              }
            }}
          >
            {props.noti &&
              props.noti.flatMap(
                (item, index) => (
                  // item.action === 'created' ? (
                  <div
                    key={index}
                    style={{
                      // padding: "16px 0px 14px 0px",
                      background: `${
                        item?.status === 'new' ? '#E8EEFF' : '#fff'
                      }`,
                    }}
                  >
                    <div
                      className={
                        'layout_header_task_dropdown_item is-flex is-justify-content-space-between is-align-items-center'
                      }
                      style={{ padding: '16px 16px 14px 6px' }}
                    >
                      <div
                        onClick={async () => {
                          const res = await PUT(
                            `${api.update_noti}/?ids=${item.id}`,
                          );
                          if (res.status === 204) {
                            props.refetchCount();
                            props.refetch();
                          }
                        }}
                        style={{
                          color: item.status === 'new' ? '#6f6f6f' : '#333',
                          width: '90%',
                        }}
                        className={
                          'is-flex is-align-items-center is-flex-direction-row img_button'
                        }
                      >
                        {item.status === 'new' ? (
                          <img
                            alt="status"
                            src="/icons/status.svg"
                            style={{
                              marginTop:
                                item.notiType === 'absence_request' ? -30 : -22,
                            }}
                          />
                        ) : (
                          <div style={{ width: '8px' }} />
                        )}
                        {item?.action === 'deleted' ||
                        item?.action === 'archived' ? (
                          <img
                            alt="receive"
                            src="/icons/deleted.svg"
                            width={28}
                            height={28}
                            style={{
                              marginLeft: '5px',
                              marginRight: '10px',
                              marginTop: -24,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          />
                        ) : item.notiType === 'absence_request' ? (
                          <img
                            alt="receive"
                            src="/icons/Message1.svg"
                            width={28}
                            height={28}
                            style={{
                              marginLeft: '8px',
                              marginRight: '10px',
                              marginTop: -30,
                            }}
                          />
                        ) : (
                          <img
                            alt="receive"
                            src="/icons/created.svg"
                            width={28}
                            height={28}
                            style={{
                              marginLeft: '8px',
                              marginRight: '10px',
                              marginTop: -24,
                            }}
                          />
                        )}

                        <div
                          style={{
                            color: '#000000',
                          }}
                        >
                          <span style={{ fontSize: 14 }}>
                            {item.notiType === 'user' ? (
                              <div>
                                {item.message ? (
                                  <>{item.message}</>
                                ) : (
                                  <div
                                    onClick={() =>
                                      handelNotification(item?.notiType)
                                    }
                                  >
                                    {item?.action === 'archived' ? (
                                      <div>
                                        <span
                                          style={{
                                            fontWeight: 700,
                                            color: 'black',
                                          }}
                                        >
                                          {!item?.data?.created_by
                                            ?.first_name &&
                                          !item?.data?.created_by?.last_name &&
                                          !item?.data?.deleted_by?.first_name &&
                                          !item?.data?.deleted_by?.last_name
                                            ? 'Admin'
                                            : item?.data?.created_by
                                                ?.first_name ||
                                              item?.data?.created_by?.last_name
                                            ? item?.data?.created_by
                                                ?.first_name +
                                              ' ' +
                                              item?.data?.created_by?.last_name
                                            : item?.data?.deleted_by
                                                ?.first_name +
                                              ' ' +
                                              item?.data?.deleted_by?.last_name}
                                        </span>{' '}
                                        moved user
                                        {` "${item?.data?.first_name} ${item?.data?.last_name}" to User Archive.`}
                                      </div>
                                    ) : (
                                      <div>
                                        <span
                                          style={{
                                            fontWeight: 700,
                                            color: 'black',
                                          }}
                                        >
                                          {!item?.data?.created_by
                                            ?.first_name &&
                                          !item?.data?.created_by?.last_name &&
                                          !item?.data?.deleted_by?.first_name &&
                                          !item?.data?.deleted_by?.last_name
                                            ? 'Admin'
                                            : item?.data?.created_by
                                                ?.first_name ||
                                              item?.data?.created_by?.last_name
                                            ? item?.data?.created_by
                                                ?.first_name +
                                              ' ' +
                                              item?.data?.created_by?.last_name
                                            : item?.data?.deleted_by
                                                ?.first_name +
                                              ' ' +
                                              item?.data?.deleted_by?.last_name}
                                        </span>{' '}
                                        {item?.action === 'created'
                                          ? 'created user '
                                          : ' removed user '}
                                        {`"${item?.data?.first_name} ${item?.data?.last_name}".`}
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            ) : item.notiType === 'absence_request' ? (
                              <div
                                onClick={() =>
                                  handelNotification(
                                    item?.notiType,
                                    item?.action,
                                  )
                                }
                              >
                                {item?.action === 'remind_approval' ? (
                                  <span
                                    style={{
                                      fontSize: 14,
                                      fontWeight: 400,
                                      color: '#000000',
                                    }}
                                  >
                                    You still have {item?.data?.approval_count}{' '}
                                    leave applications that need to be approve.
                                    Please check it.
                                  </span>
                                ) : (
                                  <div>
                                    <span>
                                      <span
                                        style={{
                                          fontWeight: 700,
                                          color: 'black',
                                        }}
                                      >
                                        {!item?.data?.processed_by
                                          ?.first_name &&
                                        !item?.data?.processed_by?.last_name
                                          ? 'Admin'
                                          : item?.data?.processed_by
                                              ?.first_name +
                                            ' ' +
                                            item?.data?.processed_by?.last_name}
                                      </span>
                                    </span>
                                    <span>
                                      {' '}
                                      {`has ${
                                        item?.data?.status === 'approved'
                                          ? 'approved'
                                          : item?.data?.status === 'rejected'
                                          ? 'rejected'
                                          : 'cancelled'
                                      }  your leave request "${
                                        item?.data?.absence_type
                                      }" on`}{' '}
                                      {dayjs(item?.created_at).format(
                                        'MM/DD/YYYY',
                                      )}
                                      {'.'}
                                    </span>
                                  </div>
                                )}
                              </div>
                            ) : user?.role === 'admin' ? (
                              <div
                                onClick={() =>
                                  handelNotification(item?.notiType)
                                }
                              >
                                {item?.notiType === 'service' ||
                                item?.notiType === 'department' ? (
                                  <span>
                                    <span>
                                      You have created{' '}
                                      {item?.notiType === 'service'
                                        ? 'service'
                                        : 'department'}{' '}
                                      {`"${
                                        item?.message?.length > 12
                                          ? item?.message?.slice(0, 10) + '...'
                                          : item?.message
                                      }".`}
                                    </span>
                                  </span>
                                ) : (
                                  <span>
                                    <span
                                      style={{
                                        fontWeight: 700,
                                        color: 'black',
                                      }}
                                    >
                                      {item?.notiType ===
                                      'public_holiday_calendar'
                                        ? 'The Public Holiday'
                                        : item?.notiType === 'workshift_policy'
                                        ? 'The Work Shift Calendar'
                                        : item?.notiType === 'absence_policy'
                                        ? 'The Staff Leave Profile'
                                        : item?.notiType === 'absence_type'
                                        ? 'The Staff Leave Types'
                                        : ''}{' '}
                                    </span>
                                    <span>
                                      {`"${
                                        item?.message?.length > 8
                                          ? item?.message?.slice(0, 6) + '...'
                                          : item?.message
                                      }"`}{' '}
                                      has been created.
                                    </span>
                                  </span>
                                )}
                              </div>
                            ) : (
                              <div>
                                <span
                                  style={{ fontWeight: 700, color: 'black' }}
                                >
                                  {!item?.data?.created_by?.first_name &&
                                  !item?.data?.created_by?.last_name
                                    ? 'Admin'
                                    : item?.data?.created_by?.first_name +
                                      ' ' +
                                      item?.data?.created_by?.last_name}
                                </span>{' '}
                                created{' '}
                                {item?.notiType === 'public_holiday_calendar'
                                  ? 'public holiday'
                                  : item?.notiType === 'workshift_policy'
                                  ? 'work shift calendar'
                                  : item?.notiType === 'absence_policy'
                                  ? 'staff leave profile'
                                  : item?.notiType === 'absence_type'
                                  ? 'staff leave type'
                                  : item?.notiType === 'service'
                                  ? 'service'
                                  : item?.notiType === 'department'
                                  ? 'department'
                                  : ''}{' '}
                                {`"${
                                  item?.message?.length > 8
                                    ? item?.message?.slice(0, 6) + '...'
                                    : item?.message
                                }".`}
                              </div>
                            )}
                            {/* {item.notiType === "absence_request" && <div>s</div>} */}
                          </span>
                          <p
                            style={{
                              marginBottom: 0,
                              fontSize: 12,
                              color:
                                item.status === 'new' ? '#407fdd' : '#6F6F6F',
                            }}
                          >
                            {typeof item.time === 'number'
                              ? `${item.time} days ago`
                              : item.time === '00:00'
                              ? 'Now'
                              : item.time.startsWith('00')
                              ? `${item.time.slice(3)} minutes ago`
                              : `${item.time} hours ago`}{' '}
                          </p>
                        </div>
                      </div>
                      <button
                        type={'button'}
                        onClick={async () => {
                          const res = await DELETE(
                            `${api.delete_noti}/?ids=${item.id}`,
                          );
                          if (res.status === 200) {
                            props.refetchCount();
                            props.refetch();
                          }
                        }}
                        className={'img_button'}
                        style={{ padding: 0 }}
                      >
                        <img
                          style={{ width: 26, height: 26, marginBottom: 5 }}
                          alt="delete"
                          src="/icons/delete.svg"
                        />
                      </button>
                    </div>
                  </div>
                ),
                // ) : null,
              )}
          </div>
        </>
      ) : (
        <div>
          <img
            style={{ top: '55px' }}
            src="/icons/empty_noti.png"
            alt="icon"
            className="image is-96x96 is-flex is-justify-content-center is-align-content-center m-auto is-relative "
          />
          <div className="is-overlay has-text-centered" style={{ top: '55%' }}>
            <p className="has-text-weight-bold mb-2">Any notification</p>
            <p>You can relax, you haven’t forgotten any info!</p>
          </div>
          <img src="/icons/empty_footer.png" alt="icon" width={'100%'} />
        </div>
      )}
    </div>
  );
};

export default NotiDropdown;
